import { ref, watch } from 'vue'

import store from '@/store/index.js'

export default () => {
  const xs = ref(false)
  const size = ref('large')
  const w = ref(window.innerWidth)
  watch(
    () => store.state.windowW,
    (nVal) => {
      w.value = nVal
      if (nVal <= 768) {
        xs.value = true
        size.value = 'small'
      } else {
        xs.value = false
        size.value = 'large'
      }
    },
    {
      immediate: true
    }
  )

  return {
    xs,
    size,
    w
  }
}
